import { DefaultedText } from '../DefaultedText';
import './BubbleTextArea.scss';

import React, { useState, useEffect } from 'react';

export interface BubbleTextAreaBase {
  value?: string;
  block?: boolean;
  inverse?: boolean;
  appearance?: 'rounded' | 'bare';
  readOnly?: boolean;
  textAreaRef?: React.Ref<HTMLTextAreaElement>;
  textAreaClassName?: string;
  textAreaStyle?: React.CSSProperties;
  onValue?: (value: string) => void;
}

export type BubbleTextAreaProps = Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'type' | 'value' | 'size'
> &
  BubbleTextAreaBase;

export default function BubbleTextArea(props: BubbleTextAreaProps) {
  const {
    // from component
    value: propValue,
    block,
    appearance,
    inverse,
    readOnly,
    textAreaRef,
    textAreaClassName: propTextAreaClasses,
    textAreaStyle: propTextAreaStyle,
    onValue,
    // from element
    className: propClasses,
    style: propStyle,
    onChange,
    ...rest
  } = props;

  const [internalValue, setInternalValue] = useState('');

  useEffect(() => {
    setInternalValue(propValue || '');
  }, [propValue]);

  function onChangeHandler(event: React.ChangeEvent<HTMLTextAreaElement>) {
    setInternalValue(event.target.value);

    event.persist();

    if (onChange) onChange(event);

    if (!props.onValue) return;
    props.onValue(event.target.value);
  }

  const classes = ['bubble-textarea-container'];
  if (block) classes.push('full');
  if (propClasses) classes.push(propClasses);

  let style: React.CSSProperties = {};
  if (propStyle) style = { ...style, ...propStyle };

  const textAreaClasses = ['bubble-textarea'];
  if (appearance) textAreaClasses.push(appearance);
  if (inverse) textAreaClasses.push('inverse');
  if (propTextAreaClasses) textAreaClasses.push(propTextAreaClasses);

  let textAreaStyle: React.CSSProperties = {};
  if (propTextAreaStyle) textAreaStyle = { ...textAreaStyle, ...propTextAreaStyle };

  return (
    <div className={classes.join(' ')} style={style}>
      {readOnly ? (
        <DefaultedText val={internalValue} />
      ) : (
        <textarea
          {...rest}
          value={internalValue}
          ref={textAreaRef}
          className={textAreaClasses.join(' ')}
          style={textAreaStyle}
          onChange={onChangeHandler}
          rows={rest.rows || 4}
        />
      )}
    </div>
  );
}
